import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import get from 'lodash.get';
import { ActionOverlay } from 'components/ActionOverlay';
import { selectors as configSelectors, Configuration, Messages } from 'services/configuration';
import { selectors as ticketingSelectors } from 'services/ticketing';
import { ExitCartOverlayProps } from '../types';

export const ExitCartOverlay = (props: ExitCartOverlayProps) => {
  const { t, i18n } = useTranslation();
  const { onCancel, onConfirm } = props;

  const configuration = useSelector(configSelectors.selectConfiguration) as Configuration;
  const ticketingPath = useSelector(ticketingSelectors.selectTicketingConfigPath);

  const cartLabel = get(configuration, `configuration.labels.cart.${i18n.language}`, t('cart.cartLabel'));
  const messages: Messages = get(configuration, `${ticketingPath}.cart.exitOverlayMessages`, {});
  const header = get(messages, `header.${i18n.language}`, t('cart.startOverOverlayHeader'));
  const subheader = get(messages, `subheader.${i18n.language}`, t('cart.startOverOverlaySubheader', { cartLabel }));
  const startOverButton = get(messages, `buttons.${i18n.language}[0]`, t('commonText.startOver'));
  const closeButton = get(messages, `buttons.${i18n.language}[1]`, t('commonText.close'));

  return (
    <ActionOverlay
      title={header}
      description={subheader}
      cancelText={startOverButton}
      confirmText={closeButton}
      onCancel={onCancel}
      onConfirm={onConfirm}
      height={500}
      style={{ background: 'rgba(255,255,255,0.95)' }}
    />
  );
};
